module.exports = __webpack_public_path__ + "img/sw1-b6.d023d83b.jpg";